import React from "react";
import { finalQuestion, product } from "../data/content";
import { BuyButton } from "./BuyButton";
import { PriceTag } from "./PriceTag";
import { ProductMockup } from "./ProductMockup";
import { Punchline } from "./Punchline";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
import { SectionTitle } from "./SectionTitle";
export function FinalQuestion() {
  return <Section labelledBy="final-title" className="bg-navy-dots text-center" data-id="element-49" data-mp="2oda9xxe2jkj9">
      <Reveal data-id="element-50" data-mp="2ofd9b8142q0n">
        <SectionTitle id="final-title" tone="dark" title={finalQuestion.title} highlight={finalQuestion.highlight} data-id="element-51" data-mp="2jn28m2yjr071" />
        <p className="mt-6 text-lg font-semibold leading-relaxed text-white sm:text-xl" data-id="element-52" data-mp="2fkfbbmj3wn2g">
          {finalQuestion.question}
        </p>
        <p className="mt-4 leading-relaxed text-white/80" data-id="element-53" data-mp="2anoxl5ury3k7">{finalQuestion.text}</p>
        <Punchline text={finalQuestion.punchline} tone="dark" className="mt-6" data-id="element-54" data-mp="25lprho7ngsjk" />
      </Reveal>

      <div className="mt-10 border-t border-white/10 pt-10" data-id="element-55" data-mp="20ozdr7jbi91b">
        <ProductMockup size="sm" data-id="element-56" data-mp="2yy29gfdwd86f" />
        <Reveal data-id="element-57" data-mp="2ywr3qa0w5qco">
          <p className="mt-6 text-lg font-bold text-white" data-id="element-58" data-mp="2yw7ox26jfi2v">{product.name}</p>
          <p className="mt-1 text-white/75" data-id="element-59" data-mp="33pk9n183j4qc">{product.tagline}</p>
          <p className="mt-2 text-sm font-semibold text-gold" data-id="element-60" data-mp="2ozmeg1br1ern">{product.verbs}</p>

          <p className="mt-8 font-bold text-white" data-id="element-61" data-mp="2oxrtwo4e3oo3">{finalQuestion.priceLead}</p>
          <div className="mt-4" data-id="element-62" data-mp="2tyz40tu08zxx">
            <PriceTag tone="dark" data-id="element-63" data-mp="3hoa4sbbcuuc2" />
          </div>
          <div className="mx-auto mt-7 max-w-md" data-id="element-64" data-mp="3hotej4quqcf0">
            <BuyButton label={finalQuestion.cta} data-id="element-65" data-mp="3mn3b9js85l2q" />
            <p className="mt-3 text-sm text-white/70" data-id="element-66" data-mp="3mmuydrw3qfrj">{finalQuestion.ctaNote}</p>
          </div>
        </Reveal>
      </div>
    </Section>;
}